// extracted by mini-css-extract-plugin
export var cell = "_4q-4";
export var headerCell = "_4q-2";
export var rowHeader = "_4q-3";
export var table = "_4q-1";
export var tableContainer = "_4q-0";